import { helpers } from '@vuelidate/validators'
import { isAfter, isBefore, parseISO } from 'date-fns'

export const validatorDateMinMax = (minDate, maxDate) =>
  helpers.withParams({ type: 'dateMinMax', minDate, maxDate }, value => {
    if (!helpers.req(value)) {
      return true
    }
    return (
      (!maxDate || !isAfter(value, parseISO(maxDate))) &&
      (!minDate || !isBefore(value, parseISO(minDate))))
  })
